import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box } from '@mui/material';
import { SIGN_FONT } from '../constants/Common';

export interface Column {
  id: string;
  label: string;
  align?: 'left' | 'right' | 'center';
  isVisible?: boolean;
  style?: React.CSSProperties;
}

interface Row {
  [key: string]: any;
}

interface Props {
  columns: Column[];
  rows: Row[];
}

const BasicTable: React.FC<Props> = ({ columns, rows }) => {
  // Calculate the equal width for each column
  const columnWidth = `${100 / columns.length}%`;

  return (
    <Box display='flex' justifyContent='center' width='90%' margin='auto'>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650,border: '1px solid black' }} aria-label='simple table'>
          <TableHead>
            <TableRow key="key1">
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align || 'left'}
                  style={{ ...column.style, width: columnWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align || 'left'}
                    style={{
                      ...column.style,
                      width: columnWidth,
                      fontFamily: column.id === 'signature' ? SIGN_FONT : undefined,
                    }}
                  >
                    {row[column.id]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default BasicTable;
